import { usePreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question/hooks";

import { useProductPlanFormModelContext } from "../../../../../context";

export const usePlanPreQuestions = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { questions } = viewModel;

	return {
		...usePreQuestions({ questions, onSetViewModel }),
	};
};
